import { type FC, useCallback, useState } from 'react';

import { CodeStep } from '@/app/[locale]/(not-authorized)/account/login/components/Login/components/TwoFaSetup/components/CodeStep';
import { ScanStep } from '@/app/[locale]/(not-authorized)/account/login/components/Login/components/TwoFaSetup/components/ScanStep';
import { Step0 } from '@/app/[locale]/(not-authorized)/account/login/components/Login/components/TwoFaSetup/components/Step0';
import { SuccessStep } from '@/app/[locale]/(not-authorized)/account/login/components/Login/components/TwoFaSetup/components/SuccessStep';
import { useBoolean } from '@/hooks/use-boolean';
import { useStepper } from '@/hooks/use-stepper';

type TwoFaSetupProps = {
  redirect: () => unknown;
};

export const TwoFaSetup: FC<TwoFaSetupProps> = (props) => {
  const { redirect } = props;

  const [qrCodeData, setQrCodeData] = useState('');
  const { value: isSuccess, setTrue: succeed } = useBoolean();

  const goToStep0 = useCallback(() => {
    setQrCodeData('');
  }, []);

  const setupStepper = useStepper([
    (stepParams) => (
      <ScanStep
        stepParams={stepParams}
        qrCodeData={qrCodeData}
        goToStep0={goToStep0}
        onSubmit={() => {
          setupStepper.goToNextStep();
        }}
      />
    ),

    (stepParams) => <CodeStep stepParams={stepParams} goToStep0={goToStep0} onSubmit={succeed} />,
  ]);

  return isSuccess ? (
    <SuccessStep goNext={redirect} />
  ) : qrCodeData ? (
    setupStepper.stepContent
  ) : (
    <Step0 onSubmit={setQrCodeData} onSkip={redirect} />
  );
};
